import { render, staticRenderFns } from "./AssociatedList.vue?vue&type=template&id=54442d44"
import script from "./AssociatedList.vue?vue&type=script&lang=js"
export * from "./AssociatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports